import {put, takeEvery, call, select} from 'redux-saga/effects';
import service from '../../services';
import {setEventsInfo} from "../API/actions";
import {API_GET_EVENTS_INFO} from "../../constants/API";
import {setEvents} from "../alerts/actions";
import {setSelectedEvent} from "../alerts/actions";
import {triggerAcknowledgeTable} from "../layouts/actions";
import { chooseServiceGenerator } from './utils';

function* getEventsInfoOcularis(action) {
    const { token } = yield select(state => state.API);
    try {
        const { data } = yield call(() => service.getEventsInfo(token));
        yield put(setEventsInfo(data))
    } catch (e) {

    }
}
function* getEventsInfoCayuga(action) {
    const { token } = yield select(state => state.API);
    const { confirm, alarmID } = action;

    const { selectedEvent, events } = yield select(state => state.alerts);
    const ind = events.indexOf(selectedEvent);

    try {
        const res = confirm 
                        ? yield call(() => service.confirmAlarm(token, selectedEvent.id))
                        : yield call(() => service.refuseAlarm(token, selectedEvent.id));
        yield put(triggerAcknowledgeTable(false));
        console.log(res);
        if (!res.error) {
            if (ind !== -1) {
                yield put(setEvents(true,
                    null,
                    [...events.slice(0, ind), ...events.slice(ind + 1)]
                ));
                yield put(setSelectedEvent(null))
            }
        }
    } catch (e) {
        console.log(e);
    }
}

export default function*(){
    yield takeEvery(API_GET_EVENTS_INFO, chooseServiceGenerator, 
        { fn: getEventsInfoOcularis, args: [] },
        { fn: getEventsInfoCayuga, args: [] },
    );
}